module.exports = __webpack_public_path__ + "img/TvDip-login.38e70b.svg";